// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import Choices from 'choices.js'
import '@hotwired/turbo'
import '@hotwired/turbo-rails'
Turbo.session.drive = false
Rails.start()
ActiveStorage.start()

import "bootstrap";
import * as bootstrap from "bootstrap";
import jquery from "jquery"
window.jQuery = jquery
window.$ = jquery
require("trix")
require("@rails/actiontext")
require("@nathanvda/cocoon")
import tippy from 'tippy.js';
import '../controllers'

const initializeChoices = function () {
  const elements = document.querySelectorAll('.choices-js');
  elements.forEach(el => {
    new Choices(el, { removeItemButton: true, shouldSort: false });
  });
}

function initializeCharts(event) {
  const chartDivs = document.querySelectorAll('.chartdiv');

  chartDivs.forEach(chartDiv => {
    const reportData = chartDiv.dataset.report;
    if (reportData) {
      chartdiv(JSON.parse(reportData), chartDiv.id);
    }
  });
}

function sessionExpiration() {
  if (!document.getElementById('sessionTimeoutModal')) {
    return;
  }

  let timeout, countdownInterval;
  const logoutUrl = "/fr/users/sign_out";
  const inactivityDuration = 1000 * 60 * 10;
  const countdownDuration = 60;

  const resetTimeout = () => {
    clearTimeout(timeout);
    clearInterval(countdownInterval);
    timeout = setTimeout(() => {
      const modal = new bootstrap.Modal(document.getElementById('sessionTimeoutModal'));
      modal.show();

      let countdown = countdownDuration;
      const countdownElement = document.getElementById('countdownTimer');
      countdownElement.textContent = countdown;

      countdownInterval = setInterval(() => {
        countdown -= 1;
        countdownElement.textContent = countdown;

        if (countdown <= 0) {
          clearInterval(countdownInterval);
          fetch(logoutUrl, {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
            }
          }).then(() => {
            window.location.href = "/";
          });
        }
      }, 1000);

      document.getElementById('continueSession').addEventListener('click', () => {
        modal.hide();
        resetTimeout();
      });

      document.getElementById('logoutSession').addEventListener('click', () => {
        clearInterval(countdownInterval);
        fetch(logoutUrl, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
          }
        }).then(() => {
          window.location.href = "/";
        });
      });
    }, inactivityDuration);
  };

  const clearSessionTimers = () => {
    clearTimeout(timeout);
    clearInterval(countdownInterval);
  };

  document.addEventListener("mousemove", resetTimeout);
  document.addEventListener("keydown", resetTimeout);
  window.addEventListener("beforeunload", clearSessionTimers);

  resetTimeout();
}

document.addEventListener("DOMContentLoaded", initializeCharts);
document.addEventListener("turbo:load", initializeCharts);

function initializeTooltips() { tippy('[data-tippy-content]'); }
document.addEventListener("DOMContentLoaded", initializeTooltips);
document.addEventListener("turbo:load", initializeTooltips);

document.addEventListener("DOMContentLoaded", sessionExpiration);
document.addEventListener("turbo:load", sessionExpiration);

document.addEventListener("DOMContentLoaded", initializeChoices);
document.addEventListener("turbo:load", initializeChoices);